
import Form from './Form'

// 全局组件
export default {
  install (Vue, options = {}) {
    Vue.use(Form)
  }
}
